import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

export const VslSection = () => {
    const videoRef = useRef(null);
    const [playing, setPlaying] = useState(false);

    const handlePlay = () => {
        videoRef.current?.play();
        setPlaying(true);
    };

    return (
        <section id="video" className="py-24 md:py-32 bg-cream">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                >
                    <p className="font-mono text-xs uppercase tracking-[0.3em] text-coral mb-4">
                        60 segundos que lo cambian todo
                    </p>
                    <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight mb-12">
                        Esto es AS Studio
                    </h2>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 60 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
                    className="relative border border-navy"
                    data-testid="vsl-container"
                >
                    <video
                        ref={videoRef}
                        data-testid="vsl-video"
                        className="w-full aspect-video object-cover"
                        poster="/media/vsl-poster.jpg"
                        controls={playing}
                        preload="metadata"
                        playsInline
                    >
                        <source src="/media/vsl.mp4" type="video/mp4" />
                        Tu navegador no soporta vídeo HTML5.
                    </video>
                    {!playing && (
                        <button
                            data-testid="vsl-play-button"
                            onClick={handlePlay}
                            aria-label="Reproducir vídeo de presentación de AS Studio"
                            className="absolute inset-0 w-full h-full flex items-center justify-center bg-navy/20 group"
                        >
                            <span className="relative flex items-center justify-center w-24 h-24 md:w-28 md:h-28 rounded-full bg-coral text-navy transition-transform duration-300 group-hover:scale-110">
                                <span className="absolute inset-0 rounded-full bg-coral animate-pulse-ring" aria-hidden="true" />
                                <Play size={36} fill="currentColor" className="relative ml-1" />
                            </span>
                        </button>
                    )}
                </motion.div>
            </div>
        </section>
    );
};
